import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
	Button,
	ContentLoader,
	ContentWrapper,
	Hourglass,
	PageLead,
	Wrapper,
	withLocalization,
} from '@adac-mp/components';
import { useViewport } from '@adac-mp/components/src/hooks/useViewport';
import { getUrlBasePath, getUuidExpiredCollection, setRouteLangParam } from '@adac-mp/shared';
import { useQuery } from '@apollo/client';

const LinkExpired = () => {
	const navigate = useNavigate();
	const { viewport } = useViewport();
	const { lang } = useParams();
	const { error, data, loading } = useQuery(getUuidExpiredCollection, {
		variables: { lang: lang || 'de' },
	});

	const labels = !error ? data?.vignettenFehlerseitenCollection.items[0] : undefined;

	const renderButton = () => (
		<div className="flex flex-col justify-center sticky left-0 right-0 bottom-0 p-1.5 gap-1.5 bg-white -mb-3 border-t border-t-gray-700 md:border-t-0 md:bg-transparent md:flex-row md:static md:gap-4 md:py-0 md:px-7">
			<Button
				className="w-full md:w-fit md:self-center px-5"
				onClick={() => {
					navigate(getUrlBasePath(`/cancel-order/vignette${setRouteLangParam(lang)}`));
				}}>
				{labels?.uuidExpiredButtonLabel || 'Neuen Link anfordern'}
			</Button>
		</div>
	);

	return (
		<>
			{loading ? (
				<ContentLoader isLoading hasPortal={false} />
			) : (
				<>
					<Wrapper className="bg-white items-center">
						<ContentWrapper>
							<PageLead
								icon={<Hourglass />}
								headline={labels?.uuidExpiredTilte || 'Hoppla!'}
								description={
									labels?.uuidExpiredText || (
										<span>
											Ihr Zugangslink ist abgelaufen. Fordern Sie einen neuen Link an,
											<br />
											um Ihre Bestellung zu verwalten.
										</span>
									)
								}
							/>
							{viewport === 'desktop' && renderButton()}
						</ContentWrapper>
					</Wrapper>
					{viewport === 'mobile' && renderButton()}
				</>
			)}
		</>
	);
};

export const LinkExpiredPage = withLocalization(LinkExpired);
